import CardContent from 'components/CardContent';
import ListWrapper from 'components/ListWrapper/ListWrapper';
import styles from './CustomerTimeline.module.scss';
import TimeLineInput from './components/TimelineInput';
import TimelineNote from './components/TimelineNote';
import Select from 'components/Select';
import {
  CUSTOMER_TIMELINE_SORT_OPTIONS,
  CUSTOMER_TIMELINE_SORT_OPTIONS_LABELS,
} from 'constants/select-options';
import {useMemo, useState} from 'react';
import {
  TimelineNote as TimelineItem,
  TimelineNoteType,
} from 'types/timeline-note';
import {useCustomerTimeline} from './useCustomerTimeline';
import Typography from 'components/Typography/Typography';

interface CustomerTimelineProps {
  customer_id: string;
  notes: TimelineItem[];
  refetch: () => void;
}

function CustomerTimeline({
  customer_id,
  notes,
  refetch,
}: CustomerTimelineProps) {
  const {onSendCustomerNote, isLoading} = useCustomerTimeline({
    customer_id,
    refetch,
  });
  const [customerTimelineFilter, setCustomerTimelineFilter] = useState<
    TimelineNoteType | 'all'
  >('all');
  const filteredNotes = useMemo(() => {
    if (customerTimelineFilter === 'all') {
      return notes;
    }
    return notes.filter((note) => note.type === customerTimelineFilter);
  }, [customerTimelineFilter, notes]);
  return (
    <ListWrapper className={styles.timelineWrapper}>
      <CardContent>
        <TimeLineInput onSubmit={onSendCustomerNote} isLoading={isLoading} />
        <div className={styles.sortContainer}>
          <Select
            placeholder="Sort by"
            options={CUSTOMER_TIMELINE_SORT_OPTIONS}
            styles={{
              control: (base) => ({
                ...base,
                marginTop: 10,
                width: '200px',
              }),
            }}
            value={{
              label:
                CUSTOMER_TIMELINE_SORT_OPTIONS_LABELS[customerTimelineFilter],
              value: customerTimelineFilter,
            }}
            onChange={(value) => setCustomerTimelineFilter(value?.value as any)}
          />
        </div>
        {filteredNotes.map((note) => (
          <TimelineNote key={note.id} note={note} />
        ))}
        {filteredNotes.length === 0 && (
          <div className={styles.noNotes}>
            <Typography variant="p">No notes found</Typography>
          </div>
        )}
      </CardContent>
    </ListWrapper>
  );
}

export default CustomerTimeline;
